<template>
  <v-container
    fluid
  >
    <v-tabs align-with-title hide-slider fixed-tabs centered>
      <v-tab :to="{ name: 'home' }" exact>Quotes</v-tab>
      <v-tab :to="{ name: 'books' }">Books</v-tab>
      <v-tab :to="{ name: 'tags' }">Tags</v-tab>
    </v-tabs>

    <router-view></router-view>

  </v-container>
</template>

<script>

export default {
  name: 'Home'
}
</script>

<style>
.v-tabs-bar .v-slide-group__prev.v-slide-group__prev--disabled {
  display: none !important;
}
.v-application--is-ltr .v-tabs--align-with-title > .v-tabs-bar:not(.v-tabs-bar--show-arrows) > .v-slide-group__wrapper > .v-tabs-bar__content > .v-tab:first-child {
  margin-left: 0 !important;
}
</style>
